export const ONLY_NUMBER = /^[0-9]+$/;

export const EMAIL =
  /^[-A-Za-z0-9!#$%&'*+/=?^_`{|}~]+(?:\.[-A-Za-z0-9!#$%&'*+/=?^_`{|}~]+)*@(?:[A-Za-z0-9](?:[-A-Za-z0-9]*[A-Za-z0-9])?\.)+[A-Za-z0-9](?:[-A-Za-z0-9]*[A-Za-z0-9])?$/;
export const USERNAME_REGEX = /^[a-zA-Z0-9][a-zA-Z0-9_.-]*$/;
export const DESCRIPTION_VALIDATION = {
  maxLength: {
    value: 2000,
    message: "Die Beschreibung darf 2000 Zeichen nicht überschreiten",
  },
};
